import { FloatingPortal, useMergeRefs } from "@floating-ui/react";
import { useFloatingLayer } from "@sellar-io/components";
import { forwardRef, HTMLProps } from "react";
import { twMerge } from "tailwind-merge";
import { usePopoverContext } from "../../hooks/usePopover";

export const PopoverContent = forwardRef<
  HTMLDivElement,
  HTMLProps<HTMLDivElement> & { portal?: boolean }
>(({ className, style, children, portal = true, ...props }, propRef) => {
  const context = usePopoverContext();
  const { popover } = useFloatingLayer();
  const ref = useMergeRefs([context.refs.setFloating, propRef]);

  if (!context.open) return null;

  const content = (
    <div
      ref={ref}
      style={{
        position: context.strategy,
        top: context.y ?? undefined,
        left: context.x ?? undefined,
        visibility: context.x == null ? "hidden" : "visible",
        ...style,
      }}
      className={twMerge(
        `${popover} overflow-auto rounded-2xl border border-zinc-300 bg-white text-zinc-800 shadow-xl`,
        className,
      )}
      {...context.getFloatingProps(props)}
    >
      {children}
    </div>
  );

  return portal ? <FloatingPortal>{content}</FloatingPortal> : content;
});

PopoverContent.displayName = "PopoverContent";
